import Route from '@ember/routing/route';

export default class LocationBillingIndexRoute extends Route {
  title = 'Billing · Home';
}
